export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 281 88" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <defs>
                <linearGradient x1="49.097314%" y1="30.2125711%" x2="51.2109203%" y2="84.9234775%" id="linearGradient-1">
                    <stop stopColor="#12F809" offset="0%"></stop>
                    <stop stopColor="#3BD267" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="49.2199295%" y1="100.723026%" x2="49.2199295%" y2="-0.723025584%" id="linearGradient-2">
                    <stop stopColor="#E0FF9C" offset="0%"></stop>
                    <stop stopColor="#12F809" stopOpacity="0.6" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-3">
                    <stop stopColor="#12F809" offset="0%"></stop>
                    <stop stopColor="#3BD267" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="0%" y1="50.0320307%" x2="100%" y2="50.0320307%" id="linearGradient-4">
                    <stop stopColor="#90FF00" offset="0%"></stop>
                    <stop stopColor="#3BD267" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50.1570868%" y1="13.5590526%" x2="50.9200242%" y2="112.923224%" id="linearGradient-5">
                    <stop stopColor="#12F809" offset="0%"></stop>
                    <stop stopColor="#3BD267" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="0%" y1="50.0079479%" x2="100%" y2="50.0079479%" id="linearGradient-6">
                    <stop stopColor="#E0FF9C" offset="0%"></stop>
                    <stop stopColor="#12F809" stopOpacity="0.6" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="10.0460081%" y1="74.4318182%" x2="86.0387939%" y2="16.6136364%" id="linearGradient-7">
                    <stop stopColor="#E0FF9C" offset="0%"></stop>
                    <stop stopColor="#38D5E0" stopOpacity="0.5" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-Off-grid-Builds-" transform="translate(-779.000000, -1676.000000)">
                    <g id="编组-41" transform="translate(320.000000, 1332.000000)">
                        <g id="2-5-48System" transform="translate(459.000000, 344.000000)">
                            <g id="资源-1">
                                <ellipse
                                    id="椭圆形备份"
                                    fill="url(#linearGradient-1)"
                                    fillRule="nonzero"
                                    cx="95.1529126"
                                    cy="53.7439024"
                                    rx="28.211165"
                                    ry="24.2560976"
                                ></ellipse>
                                <ellipse
                                    id="椭圆形"
                                    fill="url(#linearGradient-2)"
                                    fillRule="nonzero"
                                    cx="95.631068"
                                    cy="22.3536585"
                                    rx="24.8640777"
                                    ry="22.3536585"
                                ></ellipse>
                                <rect id="矩形备份" fill="url(#linearGradient-3)" fillRule="nonzero" x="31.5582524" y="0" width="19.1262136" height="78"></rect>
                                <polygon
                                    id="_4"
                                    fill="url(#linearGradient-4)"
                                    fillRule="nonzero"
                                    points="49.2522016 54.2195122 59.2912621 54.2195122 59.2912621 35.195122 49.2522016 35.195122 31.1719654 35.195122 19.9043919 35.195122 0 35.195122 0 35.195122 0 54.2195122 31.1719654 54.2195122"
                                ></polygon>
                                <polygon
                                    id="路径-2"
                                    fill="url(#linearGradient-5)"
                                    fillRule="nonzero"
                                    points="123.364078 0 146.75592 0 170.223301 78 149.903369 78"
                                ></polygon>
                                <polygon id="路径-2备份" fill="url(#linearGradient-6)" points="197 0 173.595568 0 150.140777 78 170.448119 78"></polygon>
                                <polygon id="路径-2备份" fill="url(#linearGradient-6)" points="197 0 173.595568 0 150.140777 78 170.448119 78"></polygon>
                                <path
                                    d="M22.0341436,0 L41.1213592,0 C41.1213592,0 40.0732886,50.7198891 0,54.2195122 L0,34.9715854 C0,34.9715854 16.2512598,31.9032539 22.0341436,0 Z"
                                    id="路径"
                                    fill="url(#linearGradient-7)"
                                ></path>
                            </g>
                            <g id="安全用电" transform="translate(216.000000, 0.000000)" fill="#000000" fillRule="nonzero">
                                <path d="M33.0474121,0.224671075 C36.879319,2.89495377 41.5558897,5.08413742 47.0770793,6.79222427 C52.5429069,8.48318236 58.1211397,9.48132109 63.8117552,9.78664046 C64.4779828,9.82250212 65,10.3767075 65,11.0482987 L65,45.6349519 C65,56.6093745 59.9401534,66.9623558 51.3033121,73.6598142 L33.1492603,87.7374382 C32.6964793,88.0885418 32.0652397,88.0874115 31.6137138,87.7346857 L13.5976862,73.6609197 C5.01932241,66.95968 0,56.6432823 0,45.7131166 L0,11.0153452 C0,10.3559576 0.503727586,9.80744676 1.15679828,9.75576265 C7.08479828,9.2866032 12.4657897,8.29875707 17.2997948,6.79222427 C21.755881,5.40347205 26.1222224,3.45706927 30.398819,0.953015931 L31.6790276,0.184935585 C32.1028276,-0.0753530839 32.6392121,-0.0597788113 33.0474121,0.224671075 Z M38.4320569,16.5347271 L20.1263534,42.2131649 L30.6880241,42.2131649 L24.3451,61.7361439 L45.9133776,36.2468174 L33.085,36.2468174 L38.4320569,16.5347271 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
